import { getAdminUsers } from 'utils/UserWebAPIUtils';
export function getAdminUsersQuery({ queryKey }) {
    const [, query] = queryKey;
    return getAdminUsers(query);
}
